// =============================================================================
// Track native HubSpot form completions
//
// Native HubSpot forms (see inc/inc_hubspot_form.html) post a "hsFormCallback"
// message to the window for each form lifecycle event. This listener catches
// the "onFormSubmitted" event and pushes a conversion event to the analytics
// data layers. Native OI forms do the same in form/ajax_js.html and oilib.js.
//
// Ported from the visionaryhomes theme (src/js/partial/hubspot_interest.js).
//
// 1. Push the HubSpot form GUID as `hsFormId`. A GTM variable can map the GUID
//    to a form name.
// 2. Push the `oi-contact-100` conversion event to GTM (dataLayer) and to
//    Homefiniti Analytics (hfaDataLayer).
// =============================================================================

const HUBSPOT_CONVERSION_EVENT = "oi-contact-100";

window.addEventListener("message", (event) => {
    const data = event.data;

    // Other embeds (video players, ads) also post messages. Ignore those.
    if (!data || typeof data !== "object") return;
    if (data.type !== "hsFormCallback" || data.eventName !== "onFormSubmitted") return;

    const hsFormId = data.id;
    if (!hsFormId) return;

    if ("undefined" != typeof window.dataLayer) {
        window.dataLayer.push({ hsFormId: hsFormId });
        window.dataLayer.push({ event: HUBSPOT_CONVERSION_EVENT });
    }
    if ("undefined" != typeof window.hfaDataLayer) {
        window.hfaDataLayer.push({ event: HUBSPOT_CONVERSION_EVENT });
    }
});
